import { render, staticRenderFns } from "./Zijin.vue?vue&type=template&id=3349af22&"
import script from "./Zijin.vue?vue&type=script&lang=js&"
export * from "./Zijin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports